/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SiteTwin } from '../models/site-twin';
@Injectable({
  providedIn: 'root',
})
class SiteTwinService extends __BaseService {
  static readonly SiteTwinGetSiteTwinByUriPath = '/api/SiteTwin/GetSiteTwinByUri';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `SiteTwinService.SiteTwinGetSiteTwinByUriParams` containing the following parameters:
   *
   * - `siteTypeCode`:
   *
   * - `siteTwinUri`:
   *
   * - `customerId`:
   */
  SiteTwinGetSiteTwinByUriResponse(params: SiteTwinService.SiteTwinGetSiteTwinByUriParams): __Observable<__StrictHttpResponse<SiteTwin>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteTypeCode != null) __params = __params.set('siteTypeCode', params.siteTypeCode.toString());
    if (params.siteTwinUri != null) __params = __params.set('siteTwinUri', params.siteTwinUri.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SiteTwin/GetSiteTwinByUri`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTwin>;
      })
    );
  }
  /**
   * @param params The `SiteTwinService.SiteTwinGetSiteTwinByUriParams` containing the following parameters:
   *
   * - `siteTypeCode`:
   *
   * - `siteTwinUri`:
   *
   * - `customerId`:
   */
  SiteTwinGetSiteTwinByUri(params: SiteTwinService.SiteTwinGetSiteTwinByUriParams): __Observable<SiteTwin> {
    return this.SiteTwinGetSiteTwinByUriResponse(params).pipe(
      __map(_r => _r.body as SiteTwin)
    );
  }
}

module SiteTwinService {

  /**
   * Parameters for SiteTwinGetSiteTwinByUri
   */
  export interface SiteTwinGetSiteTwinByUriParams {
    siteTypeCode?: null | string;
    siteTwinUri?: null | string;
    customerId?: number;
  }
}

export { SiteTwinService }
